<template>
  <div class="popup reminder">
	  <div class="popupblock wrong">
	    <h4>請填妥完整資料</h4>
	    <div class="bluebar"></div>
	    <p>請輸入正確 <span class="inputName"></span>欄位</p><a href="javascript:void(0)" class="close" v-on:click="closeReminder()">
	      <svg class="closebtn"><title>close</title><g data-name="close"><path d="M31.67,2.59c1.26-1.43-.84-3.55-2.1-2.1-4.2,4.78-8.72,9.26-13.3,13.69C11.84,9.47,7.4,4.78,2.58.48,1.16-.79-1,1.31.48,2.59c4.81,4.28,9.23,9,13.64,13.65C9.86,20.33,5.58,24.4,1.48,28.63c-1.33,1.38.77,3.48,2.1,2.1,4.08-4.21,8.34-8.26,12.58-12.34,4,4.24,8,8.45,12.4,12.34,1.43,1.27,3.54-.83,2.1-2.1-4.34-3.87-8.37-8.06-12.36-12.3C22.91,11.89,27.45,7.38,31.67,2.59Z" /></g></svg>
	      <svg class="arrowbg"  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 90.86 93.28"><title>btn</title><path d="M0,48.67C-.06,29,12.8,9.5,31,1.79c12.47-5.27,33.3,1.68,39.81,13.45C73.66,20.35,78,24,82.3,27.59c3,2.52,4.79,5.39,4.3,9.48-.39,3.29,1,6.16,2.46,9a15.11,15.11,0,0,1,.18,14c-12.18,25.24-30,34.78-54.36,33a16,16,0,0,1-8.06-2.36C11.93,80.51,0,68.37,0,48.67Z" /></svg></a>
	  </div>

	  <div class="popupblock right">
	    <h4>已提交申請</h4>
	    <div class="bluebar"></div>
	    <p>我們會盡快與您聯繫</p><a href="javascript:void(0)" class="close" v-on:click="closeReminder()">
	      <svg class="closebtn"><title>close</title><g data-name="close"><path d="M31.67,2.59c1.26-1.43-.84-3.55-2.1-2.1-4.2,4.78-8.72,9.26-13.3,13.69C11.84,9.47,7.4,4.78,2.58.48,1.16-.79-1,1.31.48,2.59c4.81,4.28,9.23,9,13.64,13.65C9.86,20.33,5.58,24.4,1.48,28.63c-1.33,1.38.77,3.48,2.1,2.1,4.08-4.21,8.34-8.26,12.58-12.34,4,4.24,8,8.45,12.4,12.34,1.43,1.27,3.54-.83,2.1-2.1-4.34-3.87-8.37-8.06-12.36-12.3C22.91,11.89,27.45,7.38,31.67,2.59Z" /></g></svg>
	      <svg class="arrowbg"  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 90.86 93.28"><title>btn</title><path d="M0,48.67C-.06,29,12.8,9.5,31,1.79c12.47-5.27,33.3,1.68,39.81,13.45C73.66,20.35,78,24,82.3,27.59c3,2.52,4.79,5.39,4.3,9.48-.39,3.29,1,6.16,2.46,9a15.11,15.11,0,0,1,.18,14c-12.18,25.24-30,34.78-54.36,33a16,16,0,0,1-8.06-2.36C11.93,80.51,0,68.37,0,48.67Z" /></svg></a>
	  </div>

	  <div class="fixblack"></div>
	</div>
</template>
<script>
	export default{
		methods:{
			closeReminder:function(){
				$('.reminder.popup').removeClass('show').find('.popupblock').hide();
				$('.inputName').html("");
			}
		}
	}
</script>



// WEBPACK FOOTER //
// Reminder.vue?1e6918c6